import { Logo } from '../../components/layout/Logo.jsx';
import { SubmitButton } from '../../components/SubmitButton.jsx';
import { GlobalEmbed } from '../../components/embeds/GlobalEmbed.jsx';
import { InterestRateInput } from '../../components/InterestRateInput.jsx';
import { PymFrameRuntime } from '../../components/embeds/PymFrameRuntime.jsx';

function parseUtm(href) {
  if (!href) {
    return null;
  }

  try {
    const url = new URL(href);

    return {
      source: url.host,
      content: `${url.pathname}${url.search}`,
    };
  } catch (e) {
    return null;
  }
}

function getFormSubmitUrl(form) {
  try {
    const params = new URLSearchParams(new FormData(form));

    return `${form.action}?${params}`;
  } catch (e) {
    return null;
  }
}

export default function LoanReportFormEmbed({ utm = null }) {
  function onSubmit(event) {
    const url = getFormSubmitUrl(event.target);

    if (!url) {
      return;
    }

    event.preventDefault();

    const link = document.createElement('a');

    link.setAttribute('href', url);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');

    link.click();
  }

  return (
    <GlobalEmbed>
      <PymFrameRuntime>
        <p className="paragraph">
          Finn ut om du har en høy boliglånsrente sammenlignet med resten av
          befolkningen:
        </p>
        <form
          className="form"
          method="GET"
          action="/boliglan"
          target="_blank"
          onSubmit={onSubmit}
        >
          <InterestRateInput
            label="Hva er renten din?"
            name="interestRate"
            onChange={() => {}}
          />
          <SubmitButton type="submit">Gå videre</SubmitButton>
          {utm && (
            <>
              <input type="hidden" name="utm_source" value={utm.source} />
              <input type="hidden" name="utm_content" value={utm.content} />
              <input
                type="hidden"
                name="utm_medium"
                value="loan-report-form-embed-submit"
              />
            </>
          )}
        </form>
        <div className="logo">
          <a
            className="logo__link"
            href={
              '/' +
              (utm
                ? `?utm_source=${encodeURIComponent(
                    utm.source
                  )}&utm_content=${encodeURIComponent(
                    utm.content
                  )}&utm_medium=loan-report-form-embed-logo`
                : '')
            }
            target="_blank"
          >
            <Logo color="#000" />
          </a>
        </div>
      </PymFrameRuntime>
      <style jsx>{`
        .form {
          display: flex;
          align-items: flex-end;
          font-size: 18px;
        }

        .form > :global(:first-child) {
          width: 100%;
          max-width: 200px;
          margin-right: 18px;
          margin-bottom: 0;
        }

        .form > :global(:nth-child(2)) {
          margin-bottom: 3px;
          transition: ease 0.2s all;
        }

        .form:not(:focus-within) > :global(button:not(:focus)) {
          background-color: #dfdfdf;
          color: #777;
          box-shadow: none;
        }

        .paragraph {
          margin-top: 0;
          font-weight: 600;
          line-height: 1.4;
          font-size: 18px;
        }

        .logo {
          margin-top: 18px;
        }

        .logo__link {
          display: inline-block;
          width: 100px;
          opacity: 0.5;
          transition: ease 0.2s opacity;
        }

        .logo__link:hover {
          opacity: 0.7;
        }

        @media (min-width: 650px) {
          .logo {
            margin-top: 0;
            text-align: right;
          }
        }
      `}</style>
    </GlobalEmbed>
  );
}

LoanReportFormEmbed.getInitialProps = function({ query }) {
  const { parentUrl = null } = query;

  return {
    utm: parseUtm(parentUrl),
  };
};
